export function formatDate(date?:Date | null){
  if(!date || date === null){
    return new Date().toISOString().split('T')[0];
  }
  return date.toISOString().split('T')[0];
}
